// extracted by mini-css-extract-plugin
module.exports = {"title":"title--Ci37I","successInfo":"successInfo--l1HLq"};